<script>
    import { profileData } from '../../../store';

    function counter(stat) {
        const length = $profileData[stat].length;
        return length > 99 ? length : (length > 9 ? '0'+ length : '00' + length)
    }

</script>

<style lang="scss" src="./ProfileStats.scss"></style>

<div class="profilestats">
    <ul class="profilestats__list">
        <li class="profilestats__item">
            <span class="profilestats__number">{$profileData ? counter('ideas') : '000'}</span>
            <span class="profilestats__label">Submitted ideas</span>
        </li>
        <li class="profilestats__item">
            <span class="profilestats__number">{$profileData ? counter('saved') : '000'}</span>
            <span class="profilestats__label">Liked ideas</span>
        </li>
        <li class="profilestats__item">
            <span class="profilestats__number">{$profileData ? counter('chats') : '000'}</span>
            <span class="profilestats__label">Joined chats</span>
        </li>
    </ul>
</div>